import * as React from 'react';
import { compose, setDisplayName, withHandlers, withProps } from 'recompose';
import { translate } from 'react-i18next';
import { TranslateProps } from 'util/i18n';
import { skin, OemProps } from 'ui/styles/skin';
import { X } from 'ui/shapes';
import { Input } from 'ui/shared/Input';

export type OwnProps = {
    id: string;
    filterText: string;
    onChange: (filterText: string) => void;
};

const RawCameraFilter = ({
    id,
    filterText,
    handleChange,
    handleReset,
    t,
    divStyle,
    inputStyle,
    resetStyle,
    xStyle,
}: OwnProps & RecomposeProps & TranslateProps) =>
    <div
        id={ id }
        style={ divStyle }
    >
        <Input
            id={ `${id}-input` }
            value={ filterText }
            placeholder={ t('6.1237.3078') }
            onChange={ handleChange }
            onInput={ handleChange }
            style={ inputStyle }
            autoFocus={ true }
        />
        <span
            id={ `${id}-reset` }
            title={ t('SERVER_CONFIG_BTN_CLEAR_FILTER') }
            onClick={ handleReset }
            style={ resetStyle }
            tabIndex={ 0 }
        >
            <X
                width="10px"
                height="10px"
                style={ xStyle }
            />
        </span>
    </div>
;

type RecomposeProps = {
    handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    handleReset: (e: React.MouseEvent<HTMLElement>) => void;
    divStyle: {};
    inputStyle: {};
    resetStyle: {};
    xStyle: {};
};

export const CameraFilter = compose<OwnProps & RecomposeProps, OwnProps>(
    setDisplayName('CameraFilter'),
    skin,
    withProps(({ filterText, styles }: OwnProps & OemProps) => ({
        divStyle: {
            ...styles.Input,
            position: 'relative',
            margin: '3px',
            padding: '1px',
            display: 'block',
        },
        inputStyle: {
            ...styles.Input,
            width: 'calc(100% - 20px)',
            margin: '1px',
            border: 'none',
            outline: 'none',
        },
        resetStyle: {
            position: 'absolute',
            top: 0,
            right: '5px',
            bottom: 0,
            margin: 'auto',
            height: '18px',
            cursor: filterText ? 'pointer' : 'default',
            opacity: filterText ? 1 : .5,
        },
        xStyle: {
            fill: styles.Input.color,
        },
    })),
    translate(),
    withHandlers({
        handleChange: ({ onChange }: OwnProps) => (e: React.ChangeEvent<HTMLInputElement>) => {
            onChange(e.target.value);
        },
        handleReset: ({ onChange }: OwnProps) => (e: React.MouseEvent<HTMLElement>) => {
            onChange('');
        },
    })
)(RawCameraFilter);



// WEBPACK FOOTER //
// ./src/ui/shared/CameraFilter.tsx